import { Component, NgZone, OnInit, inject } from '@angular/core';
import { Entity } from '@proman/services/entity.service';
import { Dialog } from '../services/dialog.service';
import { PromanStateService } from '../services/proman-state.service';
import { ObservablesService } from '@proman/services/observables.service';
import { BugTrackerDialogComponent } from './bug-tracker-dialog.component';
import html2canvas from 'html2canvas';
import { ACL } from '@proman/services/acl.service';
import { CurrUser } from '@proman/interfaces/object-interfaces';
import { Store } from '@ngrx/store';
import { getCurrUser } from '@proman/store/curr-user';
import { distinctUntilChanged } from '@proman/rxjs-common';
import { AuthService } from '@proman/services/auth.service';
import { PromanFile } from '@proman/interfaces/entity-interfaces';

@Component({
    selector: 'pm-account',
    template: `
        <div fxLayout="column" fxLayoutAlign="start center">
            <div class="Account"
                 fxLayout="column"
                 fxLayoutAlign="start center">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="Account-photo"
                         fxLayout="row"
                         fxLayoutAlign="center center">
                        <mat-menu #userMenu="matMenu">
                            @if (canViewProfile) {
                                <button mat-menu-item
                                        (click)="navigate('account')">
                                    <fa name="users-cog"></fa>
                                    {{ 'user_account' | translate }}
                                </button>
                            }

<!--                            <button mat-menu-item-->
<!--                                    (click)="navigate('user')">-->
<!--                                <fa name="random"></fa>-->
<!--                                {{ 'switch_user' | translate }}-->
<!--                            </button>-->

                            <button mat-menu-item
                                    (click)="navigate('billing')">
                                <fa name="credit-card"></fa>
                                {{ 'billing' | translate }}
                            </button>

                            <button mat-menu-item
                                    (click)="trackBug($event)">
                                <fa name="exclamation-triangle"></fa>
                                {{ 'support' | translate }}
                            </button>

                            <button mat-menu-item
                                    (click)="navigate('logout')">
                                <fa name="sign-out-alt"></fa>
                                {{ 'logout' | translate }}
                            </button>
                        </mat-menu>
                        <pm-user-thumb [thumb]="currUser.photo"
                                       [isUserThumb]="true"
                                       [matMenuTriggerFor]="userMenu"
                                       (click)="handleMenuOpen()"></pm-user-thumb>

                    </div>
                </div>
                <div fxLayout="row"
                     fxLayoutAlign="center center"
                     class="Account-name">
                    <div class="Account-name--label">
                        <a [routerLink]="'UserOptions' | pmSref">
                            {{ currUser.person?.firstName }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    `,
    styles: [`
        :host { overflow: hidden; }
        pm-user-thumb { width: 100%; height: 100%; }
        .newVersionAvailable {
            color: #0fd416;
            position: relative;
            top: 3px;
            left: 4px;
            font-size: 0.85em;
        }
        fa {
            padding-right: 4px;
            font-size: 0.9em;
        }
    `],
    standalone: false
})

export class AccountComponent implements OnInit {
    private NgZone = inject(NgZone);
    private store = inject(Store);
    private PromanState = inject(PromanStateService);
    private Entity = inject(Entity);
    private Dialog = inject(Dialog);
    private Observables = inject(ObservablesService);
    private Auth = inject(AuthService);
    private ACL = inject(ACL);

    currUser: CurrUser = {} as CurrUser;
    systemOptionsEntity: any;
    newVersion: boolean;
    availableCompanies: any[];
    canViewProfile: boolean;

    constructor() {


        this.systemOptionsEntity = this.Entity.get('system_options');
        this.store.select(getCurrUser)
            .pipe(distinctUntilChanged())
            .subscribe((value) => {
                this.currUser = value;
            });
    }

    ngOnInit() {
        this.Observables.userPhotoTimestamp.subscribe(() => this.loadPhoto());

        this.loadPhoto();

        window['handleCanvas'] = (event: any, canvas: any) => {
            this.NgZone.run(() => {
                this.handleCanvas(event, canvas);
            });
        };

        this.checkProfileView();
    }

    checkProfileView() {

        this.canViewProfile =
            (this.currUser.type === 'employee' || this.currUser.bookkeepingUser) ?
                this.ACL.check('employee.view') :
                (this.currUser.isAgent) ?
                    this.ACL.check('agent.view') :
                    (this.currUser.isCustomer) ?
                        this.ACL.check('customer_employee.view') :
                        false;

    }

    // switchUser() {
    //     let validTokens = this.Preferences.tokens();
    //     let users = Object.keys(validTokens);
    //
    //     if (users.length > 1) {
    //         this.Dialog
    //             .open2(UsersSwitcherDialogComponent, { users, validTokens });
    //
    //     } else {
    //         this.PromanState.to('login');
    //
    //     }
    // }

    navigate(type: any) {

        if (type === 'account') {
            this.PromanState.to('UserOptions');
        } else if (type === 'billing') {
            this.PromanState.to('billing');
        } else if (type === 'logout') {
            this.Auth.logout();

        }
    }

    loadPhoto() {
        this.Entity
            .get(this.currUser.isCustomer && 'customer_employee' || this.currUser.bookkeepingUser && 'employee' || this.currUser.type)
            .get({ id: this.currUser.person.id , select: ['id'], join: ['photo']})
            .then((response: { id: number, photo: PromanFile }) => {
                if (response) {
                    if (response.photo) {
                        this.currUser = { ...this.currUser, photo: response.photo };
                    } else {
                        if (this.currUser.isCustomer) this.Entity.get('customer').get({ id: this.currUser.customer.customer, select: ['id'], join: ['logo'] }).then((customerResponse: { id: number, logo: PromanFile }) => {
                            if (customerResponse.logo) this.currUser = { ...this.currUser, photo: customerResponse.logo };
                        })
                    }
                }
            });
    }

    handleMenuOpen = () => {
        if (this.currUser.person.isAdmin) {
            this.systemOptionsEntity
                .version()
                .then((response: any) => {
                    const version = response.version;
                    const posVersion = response.pos;

                    if (version[0] !== version[1] || posVersion[0] !== posVersion[1]) this.newVersion = true;
                });

        }

    };

    cancelCompanyConnection() {
        this.PromanState.go(true);
    }

    handleCanvas(event: any, canvas: any) {
        this.Dialog.open2(BugTrackerDialogComponent, {
            screenshot: canvas.toDataURL('image/png'),
            url: window.location.href
        });
    }

    trackBug($event: any) {
        setTimeout(() => {
            try {
                (html2canvas as any)(document.body).then((canvas: any) => window['handleCanvas']($event, canvas));
            } catch (e) {
                console.warn('html 2 canvas issue: ', e);
            }
        }, 250);
    }
}
